import d3 from '@/utils/d3importer'

export const PRIMARY_COLOR = '#1E275B'
export const SECONDARY_COLOR = '#FD204F'

let colorScales = {
  black: [
    makeColorScale(['white','#000']),
  ],
  yellows: [
    makeColorScale(['white','#fdbd2b']),
    makeColorScale(['white','#fd8336']),
    makeColorScale(['white','#fd3a64']),
    makeColorScale(['white','#da3388']),
  ],
  blues: [
    makeColorScale(['white','#7c44ca']),
    makeColorScale(['white','#00ddee']),
    makeColorScale(['white','#0000ff']),
    makeColorScale(['white','#aaddff']),
    makeColorScale(['white','#1E275B']),
  ],
  greens: [
    makeColorScale(['white','#22df44']),
    makeColorScale(['white','#080']),
    makeColorScale(['white','#44ffaa']),
  ],
  warm: [
    d3.scaleSequential(d3.interpolateWarm)
  ],
  solid: [
    makeColorScale(['#1E275B','#1E275B'])
  ]
}

let dict = {
  // comorbidityList: 'yellows',
  diseases: 'blues',
  treatments: 'greens'
}
function makeColorScale (stops) {
  if(stops[0]==='white') {
    let tmp = d3.scaleLinear().domain([0,1]).range(stops)
    stops[0] = tmp(0.1)
  }
  return d3.scaleLinear().domain([1,10]).range(stops)
}
export function getColorScale(key,idx){
  let css = (colorScales[dict[key] || key] || colorScales['black'])
  return css[(idx%css.length) || 0].copy()
}
export function getColorScales(key,count=0){
  let css = (colorScales[dict[key] || key] || colorScales['black'])
  if(count===0) count = css.length
  while(css.length<count){
    css = [...css,...css]
  }
  css = css.slice(0,count)
  return css.map((c)=>c.copy())
}